import React from 'react';
import styles from './styles.module.scss';

const DecorativeCircles = () => {
    return (
        <>
            <div className={styles.leftCircle}></div>
            <div className={styles.leftCircleSecondary}></div>
            <div className={styles.rightCircle}></div>
            <div className={styles.rightCircleSecondary}></div>
        </>
    );
};

export default DecorativeCircles;
